import { ResizableHandle } from "@duck/ui"
import { WorkspaceLayoutPane } from "../DataWorkspace/utils"
import { useAtomValue } from "jotai"
import { getPaneAtom } from "@/store/workspaceAtoms"
import { useEventEmitter } from "@/modules/EventBusModule"

interface WorkspaceResizeHandleProps {
    repaintOnPointerUp?: boolean
    enablingPanes: WorkspaceLayoutPane[]
}


export const WorkspaceResizeHandle = ({ enablingPanes, repaintOnPointerUp }: WorkspaceResizeHandleProps) => {
    const emitWorkspaceRepaintSolution = useEventEmitter('workspace:repaintSolution', 10)
    const watchedPanesStates = enablingPanes.map(pane => useAtomValue(getPaneAtom(pane)))

    const handlePointerUp = () => {
        if (!repaintOnPointerUp) {
            return
        }
        setTimeout(() => {
            emitWorkspaceRepaintSolution({})
        }, 100)
    }

    return watchedPanesStates.every(state => state) ? (
        <ResizableHandle onPointerUp={handlePointerUp} />
    ) : null
}